<template>
  <section>
    <Greeting />
  </section>

  <section class="container mx-auto">
    <About />
  </section>

  <section class="container mx-auto">
    <News />
  </section>
</template>

<script setup lang="ts">
  import Greeting from "@/views/home/components/Greeting.vue"
  import About from "@/views/home/components/About.vue"
  import News from "@/views/home/components/News.vue"
  import { useI18n } from 'vue-i18n'

  const { t, locale } = useI18n()

</script>

<style scoped lang="scss">
  section {
    position: relative;

    & + section {
      margin-top: 100px;

      p {
        margin-top: 20px;
        max-width: 80%;
      }

      &:first-child {
        margin-top: 0;
      }
    }
  }

.feature {
  &.grid-wrapper {
    grid-template-rows: max-content auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: dense;
    gap: 2rem;

    & > div {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background-color: #f9f9f9;
      position: relative;
      border-radius: 20px;

      .feature-content {
        padding: 1.8rem 2rem;

        h2 {
          margin: 1.2rem 0 1.25rem;
          font-size: 2rem;
          line-height: 2.25rem;
        }

        p {
          padding: 0 2px;
          font-size: 1.0625rem;
          line-height: 1.6;
          letter-spacing: 1px;
          color: rgba(33,33,35,.7);
        }

        small {
          color: #EF8D40;
          font-size: 14px;
          font-weight: bold;
          padding: 0 2px;
        }

        button {
          margin: 40px 2px 0;
          font-size: 14px;
          font-weight: bold;

          img {
            margin-left: 5px;
            width: 18px;
            vertical-align: -4px;
          }
        }

        .separator {
          width: calc(100% + 20px);
          height: 6px;
          margin-left: -10px;
          border-radius: 50px;

          &.blue {
            background: url('../../public/assets/img/separator_blue.png');
            background-size: cover;
          }
        }
      }
    }

    .feature-left {
      grid-row-end: span 2;

      .feature-cover {
        img {
          border-radius: 20px 20px 0 0;
        }
      }
    }

    .feature-right_1 {
      overflow: hidden;
    }
  }
}

#w1 {
  margin-bottom: 20px;
  text-align: right;

  & > span {
    margin-left: 20px;
    color: #eeeeee;
    font-size: 14px;
    font-weight: bold;
  }

  img {
    position: absolute;
    z-index: -3;
    top: -30px;
    left: 0;
  }
}

#cover {
  & > img {
    &:nth-child(2) {
      position: absolute;
      z-index: -1;
      top: 20px;
      left: -30px;
      width: 90% !important;
      filter: blur(1px);
      opacity: .55;
    }

    &:last-child {
      position: absolute;
      z-index: -2;
      top: 40px;
      left: -60px;
      width: 80% !important;
      opacity: .25;
      filter: blur(2px);
    }
  }
}

#spMachine {
  position: relative;
  margin-top: -100px;

  .feature {
    button {
      position: absolute;
      z-index: 2;
      padding: 6px 10px;
      margin-top: 45px;
      color: #fff;
      background: #ef4040;
      border-radius: 50px;

      img {
        width: 14px;
        vertical-align: -2px;
      }
    }

    table {
      margin: 95px 0 20px;
      border: 0;
      // border-radius: 15px;
      // box-shadow: 0 6px 12px rgba(83, 85, 88, 0.1);
      // background: #fff;

      td {
        min-width: 60px;
      }
    }

    #newyearTiger {
      position: absolute;
      z-index: 1;
      width: 48px;
      margin-top: 10px;
    }

    .feature-left {
      background: transparent;
      overflow: hidden;

      .feature-cover {
        height: 350px;
      }

      .feature-content {
        flex: 1;
        background: url('../../public/assets/img/feature-cover_4.png') center center;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;

        h2 {
          margin-bottom: 30px;
          // text-decoration: underline;

          img {
            width: 24px;
            margin-right: 5px;
            vertical-align: -3px;
          }
        }

        ul {
          display: inline-block;
          padding: 15px 28px;
          border-radius: 20px;
          color: rgb(185, 191, 201);
          background: rgba(0, 0, 0, .85);

          li {
            line-height: 2.2;
            font-size: 14px;
            letter-spacing: 1px;
          }
        }
      }
    }

    .feature-brief {
      margin-top: 25px;
      margin-bottom: 5px;
      padding: 0 8px;
      flex-direction: row;
      justify-content: flex-start;

      & > div {
        // flex: 1;
        flex-basis: 100px;
        opacity: .85;

        img {
          margin-left: 8px;
          // margin-bottom: 5px;
          width: 36px;
          height: 33px;
        }

        label {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
